/* tslint:disable */
/* eslint-disable */
/**
 * AddOnSelector.Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AuthenticateCustomerDto,
  AuthenticateCustomerModel,
  CustomerDto,
} from '../models';
import {
    AuthenticateCustomerDtoFromJSON,
    AuthenticateCustomerDtoToJSON,
    AuthenticateCustomerModelFromJSON,
    AuthenticateCustomerModelToJSON,
    CustomerDtoFromJSON,
    CustomerDtoToJSON,
} from '../models';

export interface ApiUsersAuthenticateProjectIdPostRequest {
    projectId: number;
    authenticateCustomerModel: AuthenticateCustomerModel;
}

export interface ApiUsersMeProjectIdGetRequest {
    projectId: number;
}

/**
 * 
 */
export class UserRoutesApi extends runtime.BaseAPI {

    /**
     */
    async apiUsersAuthenticateProjectIdPostRaw(requestParameters: ApiUsersAuthenticateProjectIdPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AuthenticateCustomerDto>> {
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId','Required parameter requestParameters.projectId was null or undefined when calling apiUsersAuthenticateProjectIdPost.');
        }

        if (requestParameters.authenticateCustomerModel === null || requestParameters.authenticateCustomerModel === undefined) {
            throw new runtime.RequiredError('authenticateCustomerModel','Required parameter requestParameters.authenticateCustomerModel was null or undefined when calling apiUsersAuthenticateProjectIdPost.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/users/authenticate/{projectId}`.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters.projectId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AuthenticateCustomerModelToJSON(requestParameters.authenticateCustomerModel),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AuthenticateCustomerDtoFromJSON(jsonValue));
    }

    /**
     */
    async apiUsersAuthenticateProjectIdPost(requestParameters: ApiUsersAuthenticateProjectIdPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AuthenticateCustomerDto> {
        const response = await this.apiUsersAuthenticateProjectIdPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async apiUsersMeProjectIdGetRaw(requestParameters: ApiUsersMeProjectIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CustomerDto>> {
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId','Required parameter requestParameters.projectId was null or undefined when calling apiUsersMeProjectIdGet.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/users/me/{projectId}`.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters.projectId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CustomerDtoFromJSON(jsonValue));
    }

    /**
     */
    async apiUsersMeProjectIdGet(requestParameters: ApiUsersMeProjectIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CustomerDto> {
        const response = await this.apiUsersMeProjectIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
